<!-- 缴费二维码 -->
<template>
    <div class="el-student-pay-qrcode">
        <el-row class="page_content">
            <h1 class="head_title">缴费</h1>
            <el-row style="text-align: center; padding: 50px 0;">
                <div v-if="loading" style="padding: 50px;">
                    <i class="el-icon-loading" style="font-size: 30px;"></i>
                    <p style="margin-top: 20px;">加载中...</p>
                </div>
                <div v-else-if="qrcodeUrl">
                    <img :src="$isHttp(qrcodeUrl)" alt="缴费二维码" style="max-width: 400px; max-height: 400px; border: 1px solid #ddd; padding: 10px; background: white;">
                    <p style="margin-top: 20px; font-size: 16px; color: #666;">请扫描二维码进行缴费</p>
                </div>
                <div v-else style="padding: 50px;">
                    <i class="el-icon-warning" style="font-size: 30px; color: #f56c6c;"></i>
                    <p style="margin-top: 20px; color: #f56c6c;">暂无缴费二维码</p>
                </div>
            </el-row>
        </el-row>
    </div>
</template>
<script>
export default {
    name: "StudentPayQRCode",
    data() {
        return {
            loading: false,
            qrcodeUrl: ""
        }
    },
    created() {
        this.getPayQRCode();
    },
    methods: {
        getPayQRCode() {
            this.loading = true;
            this.$store.dispatch("user/getPayQRCode2Student").then((ret) => {
                this.loading = false;
                if (ret.code == 0) {
                    if (ret.data) {
                        this.qrcodeUrl = ret.data || "";
                    } else {
                        this.$message.warning("未获取到缴费二维码");
                    }
                } else {
                    this.$message.error(ret.msg || "获取缴费二维码失败");
                }
            }).catch((err) => {
                this.loading = false;
                this.$message.error("获取缴费二维码失败");
            });
        }
    }
};
</script>
<style lang="less">
@import '../../styles/base.less';
.el-student-pay-qrcode {
    .page_content {
        background-color: white;
        // padding: 20px;
        border-radius: 5px;
        min-height: calc(100vh - 100px);
    }
    .head_title {
        // text-align: center;
        font-size: 24px;
        margin-bottom: 30px;
    }
}
</style>




// WEBPACK FOOTER //
// src/pages/onlinePayment/StudentPayQRCode.vue